// @ts-nocheck
import React, { useEffect, useState, useContext } from 'react';
import { createContext } from 'react';
import { ActaAuthContext } from 'pa_kit/auth.js';
import ApiService from 'services/api';
import ActaAuthUtils from 'pa_kit/utils';
import { Subscriber } from 'apps/subscribers/models/subscriber';

const SubscriberAuthContext = createContext();

export default function SubscriberAuthProvider({ children }) {

    const auth = useContext(ActaAuthContext);
    const organization = auth.organization;
    const auth_config = organization.active_licenses?.services?.auth;

    const [ subscriber, setSubscriber ] = useState();
    const [ subscriptionsHistory, setSubscriptionsHistory ] = useState();
    const [ activeSubscription, setActiveSubscription ] = useState();
    const [ isSubscriberLoading, setIsSubscriberLoading ] = useState(true);
    const [ isSubscriber, setIsSubscriber ] = useState(false);

    const handleLogout = () => {
        if (auth_config?.spid_login) {
            ActaAuthUtils.logout(auth_config);
        } else {
            try {
                ApiService.logout();
                window.location.replace('/');
            } catch (err) {
                console.log(err);
            }
        }
    };

    const checkSub = async () => {
        if (auth.user) {
            let subscriberView;
            try {
                const subscriberData = await ApiService.getUserProfile();
                subscriberView = new Subscriber(subscriberData);
                if (subscriberView) {
                    const { subscription_history, active_subscription } = await subscriberView.getSubscriptions();
                    setSubscriptionsHistory(subscription_history);
                    setActiveSubscription(active_subscription);
                }
                setSubscriber(subscriberView);
                setIsSubscriber(true);
            } catch {
                // return !auth.user.isSuperuser() && !auth.user.is('albo') && !auth.user.is('fnopo') ? handleLogout() : null;
            } finally {
                setIsSubscriberLoading(false);                
            }
        } else {
            handleLogout();
            return <></>;
        }
    };

    useEffect(() => {
        if (auth && !auth.isLoading) {
            checkSub();
        }
    }, [auth.isLoading]);

    const subscriberAuth = {
        isSubscriberLoading,
        isSubscriber,
        subscriber,
        activeSubscription,
        subscriptionsHistory
    };

    return (
        <SubscriberAuthContext.Provider value={subscriberAuth}>
            {children}
        </SubscriberAuthContext.Provider>
    );
}

export { SubscriberAuthContext }
